import React, { lazy } from "react";
import { Route, Switch } from "react-router-dom";

import Error404 from "modules/core/pages/Error404";

import { collaborationPublicRoutesConstants as routesConstants } from "./routesConstants";
import { componentLazyImport } from "modules/core/utils/helpers";

const PublicCrowdsource = lazy(() =>
  componentLazyImport(
    () => import("modules/collaboration/pages/PublicCrowdsource")
  )
);

const CollaborationPublicRoutes: React.FC = () => {
  return (
    <Switch>
      <Route path={routesConstants.crowdsource.path} exact>
        <PublicCrowdsource />
      </Route>

      <Route>
        <Error404 />
      </Route>
    </Switch>
  );
};

export default React.memo(CollaborationPublicRoutes);
